var classes = {
  "accordionPanel": "accordionPanel__9fALk",
  "fade-in": "fade-in__Gz0dw",
  "fadeInEnter": "fadeInEnter__P9v7K",
  "fadeInEnterActive": "fadeInEnterActive__1K27g",
  "fadeInEnterDone": "fadeInEnterDone__P87VJ",
  "fadeInExit": "fadeInExit__zE8o1",
  "fadeInExitActive": "fadeInExitActive__CfA-t",
  "fadeInFromTopEnter": "fadeInFromTopEnter__AlvrL",
  "fadeInFromTopEnterActive": "fadeInFromTopEnterActive__duTv7",
  "fadeInFromTopEnterDone": "fadeInFromTopEnterDone__7GJT4",
  "fadeInFromTopExit": "fadeInFromTopExit__qZh5T",
  "fadeInFromTopExitActive": "fadeInFromTopExitActive__Nua4B"
};
export { classes as default };